module.exports = __webpack_public_path__ + "media/assets/BigTwirlBlack-f2366f5c14f53e4fc6c0a7a9d630ca56.svg";